module.exports = function(notifications) {
	"use strict";
  notifications
  .controller('notificationSettingsController', notificationSettingsController)
	notificationSettingsController.$inject = ["keyPressOnlyNumber", "getDataService","refreshtokenService","postDataService","alertService","serverError","offlineError"];
	
  function notificationSettingsController(keyPressOnlyNumber, getDataService,refreshtokenService,postDataService,alertService,serverError,offlineError) {
    var vmns = this;
    var state = 'pushnotifications';
    var $data;
    vmns.notificationStatus = {};
    vmns.webPushNotificationFrequencyRequest = 1;
    vmns.ttl = 24;
    vmns.selectedCategory = {value:'default'};
    vmns.selectedPusher={value:'ms'};
    vmns.categories = [];
    vmns.checkDisabledFunction = function() {
      vmns.categories.map(function(item) {
        for (var i = 0;i < vmns.selectedCategoryArray.length;i++) {
          if(vmns.selectedCategoryArray[i]._id == item._id) {
            return item.selected = true;
          }
        }
      })
    }
    vmns.switchCategories = function(categoryId) {
      if(categoryId=='default') return
      vmns.categories.map(function(item){
        if(item._id ==categoryId){
          vmns.selectedCategoryArray.push({'_id':item._id, 'name':item.name})
          return item.selected = true
        }
      })
      vmns.selectedCategory = {value:'default'};
    }
    vmns.removeCategory = function(categoryId) {
      vmns.selectedCategoryArray.splice(vmns.selectedCategoryArray.findIndex(function(item){
        return item._id == categoryId
      }), 1);
      vmns.categories.map(function(item) {
        if(item._id==categoryId) {
          return item.selected = false
        }
      })
    }
    var getCategoriesFunction = function() {
      getDataService.get({param1:'categories', param2: null, tree:1, src:'pushsettings'}).$promise.then(function(data){      
        vmns.categories = data.categories;
        vmns.checkDisabledFunction()
      }, function(error){
        if(!window.navigator.onLine) {
          offlineError()
          return
        }
        if(error.status == 401) {
          var promise = refreshtokenService.getAccessToken();
            promise.then(
              function(answer) {
                if(answer==200) {
                  getCategoriesFunction();
                }
              },
              function(error) {
                // report something
              },
              function(progress) {
               // report progress
              });
        } else if(error.status ==502) {
          serverError()
        }
      });
    }
    vmns.keyPressOnlyNumber = keyPressOnlyNumber
    var getNotificationSettings = function() {
      getDataService.get({
        param1: state,
        param2: 'settings'
        }).$promise.then(function(data){
        vmns.selectedCategoryArray = data.categories;
        vmns.selectedPusher.value = data.iosCluster;
        vmns.webPushNotificationFrequencyRequest = parseInt(data.remindInterval);
        vmns.ttl = parseInt(data.ttl);
        getCategoriesFunction();
      }, function(error){
        if(!window.navigator.onLine) {
          offlineError('refresh')
          return
        }
        if(error.status ==401) {
          var promise = refreshtokenService.getAccessToken();
          promise.then(
            function(answer) {
              if(answer==200) {
                getNotificationSettings();
              }
              // do something
            },
            function(error) {
            },
            function(progress) {
             // report progress
            });
        } else if(error.status ==502) {
            serverError()
        } else {
          alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
        }
        
      });
    }
    getNotificationSettings()  
    vmns.saveWebSettings = function() {
      if(!parseInt(vmns.webPushNotificationFrequencyRequest) || !parseInt(vmns.ttl) || vmns.selectedCategoryArray.length==0) return;
      var data = {
        'remindInterval': parseInt(vmns.webPushNotificationFrequencyRequest),
        'ttl': parseInt(vmns.ttl),
        'categories' : vmns.selectedCategoryArray,
        'iosCluster': vmns.selectedPusher.value
      }
      var postFunction = function() { 
        postDataService.save({
          param1:state,
          param2: 'settings',
        },data).$promise.then(function(postData){
          if(data.categories) {
            vmns.selectedCategoryArray = data.categories;
          }
          if(postData.data.remindInterval) {
            vmns.webPushNotificationFrequencyRequest = parseInt(postData.data.remindInterval);
          }
          if(postData.data.ttl) {
            vmns.ttl = parseInt(postData.data.ttl)
          }
          alertService('success','Success ', postData.message, 2000);
        }, function(error){
          if(!window.navigator.onLine) {
            offlineError()
            alertService('danger','Opps! ', 'Please check your internet connection and try again.');
            return
          }
          if(error.status ==401) {
            var promise = refreshtokenService.getAccessToken();
            promise.then(
              function(answer) {
                if(answer==200) {   
                  postFunction();
                }
              },
              function(error) {
                // report something
              },
              function(progress) {
               // report progress
            });
          }else if(error.status ==502) {
            serverError()
          } else {
            alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
          }
        });
      }
      postFunction();
    }
    
  }	
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/notificationsModule/notificationsettings/js/notificationSettingsController.js
// module id = 534
// module chunks = 0